// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__--cxK","toggle":"styles_toggle__2zhxc","preview":"styles_preview__3Eszf"};